import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

let lockCount = 0;
let originalOverflow = '';

export const lockBodyScroll = () => {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
};

export const unlockBodyScroll = () => {
  if (typeof document === 'undefined') return;
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = originalOverflow;
  }
};

export const useLockBodyScroll = () => {
  useEffect(() => {
    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, []);
};

export const RidePortal = ({ children }) => {
  useLockBodyScroll();
  if (typeof document === 'undefined') return children;
  return ReactDOM.createPortal(children, document.body);
};

export default RidePortal;
